import React, { SVGProps } from 'react';

type PublicSessionLoginSuccessProps = SVGProps<SVGSVGElement>;

export function PublicSessionLoginSuccess({ ...props }: PublicSessionLoginSuccessProps): JSX.Element {
  return (
    <svg width='220' height='220' viewBox='0 0 220 220' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g id='Illustration Container'>
        <g id='Group 2'>
          <path
            id='Vector'
            opacity='0.08'
            d='M220 110C220 170.751 170.751 220 110 220C49.2487 220 0 170.751 0 110C0 49.2487 49.2487 0 110 0C170.751 0 220 49.2487 220 110Z'
            fill='#8DA1B4'
          />
          <path
            id='Vector_2'
            opacity='0.1'
            d='M198.289 110C198.289 158.761 158.761 198.289 110 198.289C61.239 198.289 21.7104 158.761 21.7104 110C21.7104 61.2391 61.239 21.7105 110 21.7105C158.761 21.7105 198.289 61.2391 198.289 110Z'
            fill='#446583'
          />
        </g>
        <path
          id='Vector 8'
          d='M61.1428 118.5L88.1428 145.5L158.643 75'
          stroke='#0075E0'
          strokeWidth='8'
          strokeLinecap='round'
        />
      </g>
    </svg>
  );
}
